import './checkbox.module.scss';
import { sanitize } from '@msc-b2c/shared-utils';
import { ReactNode, ChangeEvent } from 'react';

export const Checkbox = ({
  id,
  name,
  text,
  checked,
  disabled,
  styleOptions,
  onChange,
}: {
  id?: string;
  name?: string;
  text?: string | ReactNode;
  checked: boolean;
  disabled?: boolean;
  styleOptions?: string;
  onChange: (event?: ChangeEvent<HTMLInputElement>) => void;
}) => {
  return (
    <div className={`options react-options ${styleOptions}`}>
      <div className="cmp-form-options--checkbox">
        <label
          className="cmp-form-options__field-label"
          htmlFor={id}
        >
          <input
            type="checkbox"
            id={id}
            name={name}
            onChange={(event) => {
              if (disabled) return;
              onChange(event);
            }}
            checked={checked}
            disabled={disabled}
          />
          {text &&
            (typeof text === 'string' ? (
              <span
                dangerouslySetInnerHTML={{ __html: sanitize(text) }}
                className={`cmp-form-options__field-description`}
              ></span>
            ) : (
              <span className={`cmp-form-options__field-description`}>{text}</span>
            ))}
        </label>
      </div>
    </div>
  );
};
